export enum ReplaceMeterStep {
  OldValues = 1,
  NewValues,
  Details,
  Review,
}
